<template>
  <div class="menu-topbar">
    <div class="topbar-container">
      <!-- 菜单搜索 -->
      <!-- <div class="search-wrapper">
        <input
          type="text"
          placeholder="请输入菜单名称"
          class="search-input"
          v-model="menuName"
          @keyup.enter="searchMenu"
        />
        <button class="search-confirm-button" @click="searchMenu">搜索</button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 菜单搜索
      menuName: "",
    };
  },
  created() {},
  methods: {
    // 搜索学生姓名
    searchMenu() {
      if (!this.menuName) {
        this.$message.warning("请输入菜单名称!");
        return;
      } else {
        this.$emit("searchMenu", this.menuName);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./menuManageTopbar.scss";
</style>